import script from "./qrBillPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./qrBillPayment.vue?vue&type=script&setup=true&lang=js"

import "./qrBillPayment.vue?vue&type=style&index=0&id=30a91a94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a91a94"]])

export default __exports__